import React, { useState } from "react";
import "./BountyModal.css";

const BountyModal = ({
  isOpen,
  onClose,
  onConfirm,
  userReputation,
  loading,
}) => {
  const [amount, setAmount] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = () => {
    const numAmount = parseInt(amount);

    if (!amount || isNaN(numAmount)) {
      setError("Please enter a valid number");
      return;
    }

    if (numAmount < 50) {
      setError("Minimum bounty is 50 reputation points");
      return;
    }

    if (numAmount > 10000) {
      setError("Maximum bounty is 10,000 reputation points");
      return;
    }

    if (numAmount > userReputation) {
      setError("Insufficient reputation points");
      return;
    }

    onConfirm(numAmount);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && amount && !loading) {
      handleSubmit();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="bm-overlay" onClick={onClose}>
      <div className="bm-content" onClick={(e) => e.stopPropagation()}>
        <div className="bm-header">
          <h3 className="bm-title">🏆 Add Bounty</h3>
          <button className="bm-close-btn" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>

        <div className="bm-body">
          <p className="bm-description">
            Offer reputation points to attract quality answers to your question
          </p>

          <div className="bm-user-reputation">
            Your reputation: <strong>{userReputation || 0} points</strong>
          </div>

          <div className="bm-form-group">
            <label htmlFor="bounty-amount">Bounty Amount *</label>
            <input
              id="bounty-amount"
              type="number"
              value={amount}
              onChange={(e) => {
                setAmount(e.target.value);
                setError("");
              }}
              onKeyPress={handleKeyPress}
              min="50"
              max="10000"
              placeholder="Enter amount (50-10,000)"
              autoFocus
            />
            <small className="bm-help-text">
              Minimum: 50 points | Maximum: 10,000 points
            </small>
            {error && <div className="bm-error-message">{error}</div>}
          </div>
        </div>

        <div className="bm-actions">
          <button
            onClick={onClose}
            className="bm-cancel-btn"
            disabled={loading}
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="bm-submit-btn"
            disabled={loading || !amount}
          >
            {loading ? "Adding Bounty..." : "Add Bounty"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BountyModal;
